var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRotateForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 40V200C496 213.25 485.25 224 472 224H312C298.75 224 288 213.25 288 200S298.75 176 312 176H412.463C382.775 118.281 322.545 80 256 80C158.969 80 80 158.969 80 256S158.969 432 256 432C297.094 432 337.094 417.531 368.625 391.25C378.781 382.75 393.937 384.094 402.437 394.312C410.937 404.5 409.562 419.625 399.375 428.125C359.219 461.562 308.312 480 256 480C132.5 480 32 379.5 32 256S132.5 32 256 32C335.848 32 408.262 75.566 448 142.094V40C448 26.75 458.75 16 472 16S496 26.75 496 40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRotateForward);
export default __webpack_public_path__ + "static/media/arrow-rotate-forward.4de169b58a7d100acebac95b9ad2b7b0.svg";
export { ForwardRef as ReactComponent };